module.exports = __webpack_public_path__ + "static/media/KohinoorBangla-Bold.578a7e3c.svg";